import { CollectionShort } from "../types/Collection";
import { API_URL } from "../utils";

export default async (id: number, page: number = 0): Promise<CollectionShort> => {
	const headers = new Headers();

	const result: { data: CollectionShort; errors: string } = await(
		await fetch(`${API_URL}/collections/collection?id=${id}&page=${page}`, {
			credentials: 'include'
		})
	).json();

	if (!result.errors) {
		return result.data;
	}

	return null;
};
